import React from 'react';
import MultiButtonSwitch from '../common/editors/MultiButtonSwitch';

// Workflow states (mirrors model/schemas/schemaModelMiniature.js `states`).
export const MINIATURE_STATES = ['inprogress', 'review', 'published', 'unpublished', 'failed'];

export const STATE_COLORS = {
  inprogress: 'warning',
  review: 'info',
  published: 'success',
  unpublished: 'secondary',
  failed: 'danger',
};

export const STATE_EMOJI = { inprogress: '🚧', review: '👀', published: '✅', unpublished: '⛔', failed: '❌' };

// Miniature images are stored only as an S3 key (image.name) in the same bucket used for the
// processed/webp variants. ImagePreview derives the sized/cloudfront URL from this full URL.
const IMAGE_BASE_URL = 'https://rewise-images.s3.amazonaws.com';
export function miniatureImageUrl(image) {
  if (!image || !image.name) return null;
  return image.name.startsWith('http') ? image.name : `${IMAGE_BASE_URL}/${image.name}`;
}

export function MiniatureStateSwitch({ value, onChange, multi = false, compact = false }) {
  const options = MINIATURE_STATES.map((s) => ({ value: s, label: compact ? (STATE_EMOJI[s] || s) : s }));
  return <MultiButtonSwitch multi={multi} value={value} onChange={onChange} options={options} optionColorMap={STATE_COLORS} />;
}
